import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";
import FlowstationPerformanceStore from "../../store/FlowstationPerformanceStore";
import { createContext } from "react";
import { toJS } from "mobx";
import { Skeleton } from "antd";

const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);

export const FlowstationOilProductionChart = ({ showLabel, showLegend }) => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );

  return (
    <Observer>
      {() =>
        flowstationPerformanceStore.isLoading ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                type: "column",
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                style: { fontSize: "14px" },
                text: `<b>Flowstation Oil (bopd)</b> <br/>${flowstationPerformanceStore.selMonthName},${flowstationPerformanceStore.selYear}`,
              },

              xAxis: {
                categories: [
                  ...flowstationPerformanceStore.flowstationProductions.values(),
                ].map((x) => toJS(x.flowstation)),
                crosshair: true,
                title: {
                  text: "Flowstation",
                },
              },
              yAxis: {
                min: 0,
                title: {
                  text: "Oil (bopd)",
                },
              },
              legend: {
                enabled: showLegend,
                floating: false,
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
              tooltip: {
                headerFormat:
                  '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat:
                  '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y:.2f} bopd</b></td></tr>',
                footerFormat: "</table>",
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.2,
                  borderWidth: 0,
                },
              },
              series: [
                {
                  name: "Oil (bopd)",
                  data: [
                    ...flowstationPerformanceStore.flowstationProductions.values(),
                  ].map((x) => Math.round(toJS(x.oil_Volume))),
                  color: "red",
                  dataLabels: {
                    enabled: showLabel,
                  },
                },
              ],
              responsive: {
                rules: [
                  {
                    condition: {
                      maxWidth: 1000,
                    },
                    chartOptions: {
                      legend: {
                        enabled: showLegend,
                        floating: false,
                        layout: "horizontal",
                        align: "center",
                        verticalAlign: "bottom",
                        x: 0,
                        y: 0,
                      },
                      yAxis: [
                        {
                          labels: {
                            align: "right",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          labels: {
                            align: "left",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          visible: false,
                        },
                      ],
                    },
                  },
                ],
              },
            }}
          />
        )
      }
    </Observer>
  );
};

